// Subdomain-aware portal helpers.
// Login unificado em clientes.zemocapital.com — parceiros.* NÃO tem login próprio.

const host = typeof window !== "undefined" ? window.location.host || "" : "";

export const PORTAL_MODE = host.startsWith("clientes.")
  ? "cedente"
  : host.startsWith("parceiros.")
  ? "partner"
  : "multi";

export const CEDENTE_BASE = PORTAL_MODE === "cedente" ? "" : "/cedente";

export const cedentePath = (path = "/") =>
  `${CEDENTE_BASE}${path.startsWith("/") ? path : `/${path}`}`.replace(/\/$/, "") || "/";

export const partnerPath = (path = "/") =>
  path.startsWith("/") ? path : `/${path}`;

// Subdomain hosts (production).
export const PARTNER_HOST = "parceiros.zemocapital.com";
export const CEDENTE_HOST = "clientes.zemocapital.com";

// Login unificado — sempre em clientes.*
export function loginUrl() {
  if (PORTAL_MODE === "partner") return `https://${CEDENTE_HOST}/login`;
  return "/login";
}

// Returns absolute URL for the partner portal (only when on cedente subdomain)
export function partnerSubdomainUrl(path = "/dashboard") {
  if (PORTAL_MODE === "cedente") return `https://${PARTNER_HOST}${path}`;
  return null;
}

// Returns absolute URL for the cedente portal (only when on partner subdomain)
export function cedenteSubdomainUrl(path = "/operacoes") {
  if (PORTAL_MODE === "partner") return `https://${CEDENTE_HOST}${path}`;
  return null;
}

// After-login destination based on portal_type
export function landingForUser(user) {
  if (!user) return "/login";
  if (user.portal_type === "cedente") return cedentePath("/operacoes");
  // Partner users on cedente portal → redirect cross-domain
  if (PORTAL_MODE === "cedente") return null; // signals cross-domain redirect needed
  return "/dashboard";
}
